"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var EventType_1 = require("../types/EventType");
var VariantId_1 = require("../types/VariantId");
var ExperimentId_1 = require("../types/ExperimentId");
var AbstractEvent_1 = require("./AbstractEvent");
var ExperimentAssignedEvent = (function (_super) {
    __extends(ExperimentAssignedEvent, _super);
    function ExperimentAssignedEvent(experimentId, variantId) {
        var _this = _super.call(this) || this;
        _this.props = new ExperimentAssignedEventProperties(new ExperimentId_1.ExperimentId(experimentId), new VariantId_1.VariantId(variantId));
        return _this;
    }
    ExperimentAssignedEvent.prototype.getType = function () {
        return EventType_1.EventType.ExperimentAssigned;
    };
    return ExperimentAssignedEvent;
}(AbstractEvent_1.AbstractEvent));
exports.ExperimentAssignedEvent = ExperimentAssignedEvent;
var ExperimentAssignedEventProperties = (function () {
    function ExperimentAssignedEventProperties(experiment_id, variant_id) {
        this.experiment_id = experiment_id;
        this.variant_id = variant_id;
    }
    return ExperimentAssignedEventProperties;
}());
//# sourceMappingURL=ExperimentAssignedEvent.js.map